(function () {
	'use strict';

	// TODO: Seems it can be moved to mxComponents

	angular.module('mx.SolutionBuilderAgent').component('mxCarousel', {
		bindings: {
			data: '<',
			subjectFieldName: '@',
			bodyFieldName: '@',
			hidePaging: '@',
			disablePaging: '@',
			parentControl: '=?',
		},
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-carousel/mx-carousel.html',
		controllerAs: 'vm',
		controller: MxCarouselCtrl,
	});

	MxCarouselCtrl.$inject = ['mx.shell.InternationalizationService'];

	function MxCarouselCtrl(i18nService) {
		var vm = this;
		vm.isRtl = i18nService.currentLanguage.isRightToLeft;
		vm._data = [];

		vm.$onInit = function () {
			vm.currentPosiiton = 0;
		};

		Object.defineProperty(vm, 'isPagingDisabled', {
			get: function () {
				return vm.disablePaging === 'true';
			},
		});

		Object.defineProperty(vm, 'data', {
			set: function (newValue) {
				if (!Array.isArray(newValue)) {
					return;
				}
				if (vm._data.length !== newValue.length && vm.currentPosiiton !== 0) {
					vm.changeSlide(0);
				}
				vm._data = [...newValue];
				if (vm.isRtl) {
					vm._data = vm._data.reverse();
				}
			},
			get: function () {
				return vm._data;
			},
		});

		vm.changeSlide = function (newPosition) {
			vm.offsetX = (((vm.isRtl ? 1 : -1) * newPosition) / vm.data.length) * 100;
			vm.currentPosiiton = newPosition;
		};

		vm.nextSlide = function () {
			vm.changeSlide((vm.currentPosiiton + 1) % vm.data.length);
		};

		vm.prevSlide = function () {
			vm.changeSlide(vm.currentPosiiton === 0 ? vm.data.length - 1 : vm.currentPosiiton - 1);
		};
	}
})();
